import api from './api';

// Client delle rotte dedicate del connettore Live Chat. Il connettore NON passa
// dalle rotte generiche /connectors/livechat (rispondono 400 USE_DEDICATED_ROUTE).
const botBase = (ws, botId) => `/workspaces/${ws}/bots/${botId}/livechat`;

// { enabled, handoverTeamId, handoverUrl, available, teamName }
// `withTeamName` chiede al backend di risolvere il nome del team sull'handover (più lento: solo dove serve)
export async function getLiveChatStatus(ws, botId, { withTeamName } = {}) {
  const response = await api.get(botBase(ws, botId), withTeamName ? { params: { withTeamName: 1 } } : undefined);
  return response.data.data;
}

// { teams: [{ _id, name }] }
export async function getLinkableTeams(ws, botId) {
  const response = await api.get(`${botBase(ws, botId)}/linkable-teams`);
  return response.data.data;
}

// { team: { _id, name } }; senza teamId l'handover crea un team nuovo
export async function activateLiveChat(ws, botId, teamId) {
  const response = await api.post(`${botBase(ws, botId)}/activate`, teamId ? { teamId } : {});
  return response.data.data;
}

// { crafterSync: 'ok' | 'failed' | 'local' }
export async function deactivateLiveChat(ws, botId) {
  const response = await api.post(`${botBase(ws, botId)}/deactivate`);
  return response.data.data;
}

// { handoverUrl, links: { [botId]: teamId } }
export async function getWorkspaceLiveChatLinks(ws) {
  const response = await api.get(`/workspaces/${ws}/livechat/links`);
  return response.data.data;
}
